import ImagePreviewModel from "crop-image/src/ImagePreviewModel";
import { mapToCropRequest } from "@/frameworks/imagePreviewModelMapper";
import UpdateRewardRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/Reward/UpdateRewardRequest";
import RewardResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/Reward/RewardResponse";
import TranslationItemModel from "@models/translationItemModel";
import RewardTranslationsUpdateRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/Reward/RewardTranslationsUpdateRequest";

export class UpdateRewardModel {
  id?: number = null;
  iconImage: ImagePreviewModel = new ImagePreviewModel();
  translations: Array<TranslationItemModel> = null;
  trigger: number = 0;
  count: number;

  initLanguages(languages: string[]) {
    this.translations = languages.map(
      (x) =>
        new TranslationItemModel({
          langCode: x,
        })
    );
  }

  toServerModel(): UpdateRewardRequest {
    const req = new UpdateRewardRequest({
      RewardId: this.id,
      Count: this.count,
      Icon:
        this.iconImage.Height && this.iconImage.Width
          ? mapToCropRequest(this.iconImage)
          : null,
      Trigger: this.trigger,
      Translations: this.translations.map(
        (x) =>
          new RewardTranslationsUpdateRequest({
            LangCode: x.langCode,
            Name: x.name,
            Description: x.description,
          })
      ),
    });
    return req;
  }

  fromServerModel(model: RewardResponse) {
    this.id = model.Id;
    this.trigger = model.Trigger;
    this.count = model.Count;
    this.iconImage.ImageUrl = model.Icon;
    this.translations.forEach((tr) => {
      const serverTranslation = model.Translations.find(
        (x) => x.LangCode == tr.langCode
      );
      if (serverTranslation != null) {
        tr.name = serverTranslation.Name;
        tr.description = serverTranslation.Description;
      }
    });
  }
}
